module.exports = __webpack_public_path__ + "static/media/map.f25ace2a.png";